module.exports = __webpack_public_path__ + "img/track-jr-bg.9a80f87f.svg";